import React from "react";

interface BadgeProps {
  variant?: "ok" | "warn" | "bad" | "info" | "ghost" | "";
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export function Badge({ variant = "", style, children }: BadgeProps) {
  return <span className={`badge ${variant}`} style={style}>{children}</span>;
}

/** Pipeline-style badge (done/pending) */
export function PipelineBadge({
  done,
  positiveLabel = "Đã xong",
  negativeLabel = "Chờ xử lý",
}: {
  done: boolean;
  positiveLabel?: string;
  negativeLabel?: string;
}) {
  return (
    <span className={done ? "badge ok" : "badge warn"}>
      {done ? positiveLabel : negativeLabel}
    </span>
  );
}
